import { BuilderComponent, BuilderContent } from '@builder.io/react';
import { FC } from 'react';

import { getBlockDataMap } from '../builder';
import B2BLayout from '../components/layouts/b2b-layout';
import MetaBlock from '../components/meta-block/MetaBlock';
import { useLocale } from '../helpers/LangHelper';

interface Props {
    page: any;
    model: string;
}

export const B2BPage: FC<Props> = (props) => {
    const { page, model } = props;
    const { locale } = useLocale();

    return (
        // https://www.builder.io/c/docs/ab-data-models#getting-the-correct-variation
        <B2BLayout page={page} model={model}>
            <MetaBlock title={page?.data?.title} description={page?.data?.description} />
            <BuilderContent key={page?.id} model={model} content={page}>
                {(variant, loading, content) => {
                    return (
                        <BuilderComponent
                            locale={locale}
                            model={model}
                            key={page?.id}
                            entry={page?.id}
                            content={content}
                            data={{
                                ...getBlockDataMap({ data: variant }),
                                ...(variant || {}),
                            }}
                        />
                    );
                }}
            </BuilderContent>
        </B2BLayout>
    );
};

export default B2BPage;
